import { createVanIconComponent } from "./van"

const VolumeOutlined = createVanIconComponent("volume-o")
export default VolumeOutlined
